export default __webpack_public_path__ + "static/governance-9235fe8e443cd8c0c558eaa9f18ab1e5.png";